import React from 'react';
import { FadeIn } from './FadeIn';
import { ArrowRight } from 'lucide-react';
export function Services() {
  const services = [{
    title: 'Hatha Yoga',
    description: 'Traditional foundational postures and breathing techniques to align and calm your body, mind, and spirit.',
    image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&q=80&w=800',
    duration: '60 mins'
  }, {
    title: 'Power Yoga',
    description: 'A vigorous, fitness-based approach to vinyasa-style yoga. Builds strength, stamina, and flexibility.',
    image: 'https://images.unsplash.com/photo-1593164842264-854604db2260?auto=format&fit=crop&q=80&w=800',
    duration: '60 mins'
  }, {
    title: 'Meditation & Pranayama',
    description: 'Guided breathwork and meditation sessions to reduce stress, improve focus, and promote inner peace.',
    image: 'https://images.unsplash.com/photo-1528319725582-ddc096101511?auto=format&fit=crop&q=80&w=800',
    duration: '45 mins'
  }, {
    title: 'Yoga for Weight Loss',
    description: 'Dynamic sequences designed to boost metabolism, burn calories, and tone muscles naturally.',
    image: 'https://images.unsplash.com/photo-1603988363607-e1e4a66962c6?auto=format&fit=crop&q=80&w=800',
    duration: '60 mins'
  }, {
    title: 'Yoga for Back Pain',
    description: 'Therapeutic postures focusing on spinal health, core strengthening, and relieving chronic back tension.',
    image: 'https://images.unsplash.com/photo-1552286450-37b5f6358cb7?auto=format&fit=crop&q=80&w=800',
    duration: '60 mins'
  }, {
    title: 'Prenatal Yoga',
    description: 'Safe, gentle practices to support expecting mothers physically and emotionally throughout pregnancy.',
    image: 'https://images.unsplash.com/photo-1518611012118-696072aa579a?auto=format&fit=crop&q=80&w=800',
    duration: '60 mins'
  }];
  return <section id="services" className="py-24 bg-white" data-id="element-311">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-312">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-313">
          <FadeIn className="max-w-2xl" data-id="element-314">
            <span className="text-yoga-primary font-bold uppercase tracking-wider text-sm block mb-2" data-id="element-315">
              Our Offerings
            </span>
            <h2 className="text-4xl md:text-5xl font-bold text-yoga-dark mb-4" data-id="element-316">
              Classes tailored for every goal
            </h2>
            <p className="text-lg text-yoga-muted" data-id="element-317">
              Explore our diverse range of yoga styles. Whether you seek
              relaxation, strength, or healing, we have a class for you.
            </p>
          </FadeIn>
          <FadeIn delay={200} data-id="element-318">
            <a href="#schedule" className="hidden md:inline-flex items-center gap-2 text-yoga-primary font-bold hover:text-yoga-dark transition-colors" data-id="element-319">
              View full schedule <ArrowRight className="w-5 h-5" data-id="element-320" />
            </a>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-321">
          {services.map((service, index) => <FadeIn key={index} delay={index * 100} data-id="element-322">
              <div className="group rounded-2xl overflow-hidden bg-yoga-warm border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300 flex flex-col h-full" data-id="element-323">
                <div className="relative h-64 overflow-hidden" data-id="element-324">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700" data-id="element-325" />
                  <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-bold text-yoga-dark" data-id="element-326">
                    {service.duration}
                  </div>
                </div>
                <div className="p-8 flex flex-col flex-grow" data-id="element-327">
                  <h3 className="text-2xl font-bold text-yoga-dark mb-3 group-hover:text-yoga-primary transition-colors" data-id="element-328">
                    {service.title}
                  </h3>
                  <p className="text-yoga-muted mb-6 flex-grow" data-id="element-329">
                    {service.description}
                  </p>
                  <a href="#contact" className="inline-flex items-center gap-2 text-yoga-dark font-bold group-hover:text-yoga-primary transition-colors mt-auto" data-id="element-330">
                    Book this class <ArrowRight className="w-4 h-4" data-id="element-331" />
                  </a>
                </div>
              </div>
            </FadeIn>)}
        </div>

        <div className="mt-10 text-center md:hidden" data-id="element-332">
          <a href="#schedule" className="inline-flex items-center gap-2 text-yoga-primary font-bold" data-id="element-333">
            View full schedule <ArrowRight className="w-5 h-5" data-id="element-334" />
          </a>
        </div>
      </div>
    </section>;
}